import { IFBFriend } from '../SDK/SDKfb';

export interface IInvite {
    ts: number;
    id: string;
}

export interface IConfirmedInvite {
    avatar: string;
    name: string;
    userId: string;
}

export interface IReceivedInvite {
    ts: number;
    fromId: string;
}

export interface IShareGiftData {
    friendId: string;
    ts: number;
}

export interface IStateSocial {
    pendingInvitations: IInvite[];
    confirmedInvitations: IConfirmedInvite[];
    receivedInvitations: IReceivedInvite[];
    optInRewardDate: number;
    optInShown: boolean;
    messageIds: string[];
    gifts: Array<[string, number, string?]>;
    giftFromFriend: string;
    optInRequired: boolean;
    nativeOptInRequired: boolean;
    sharedGiftsCount: number;
    sentCoins: IShareGiftData[];
    sentGifts: IShareGiftData[];
    requestedGifts: IShareGiftData[];
    helperFriend: IFBFriend;
}

export const defaultStateSocial: IStateSocial = {
    pendingInvitations: [],
    confirmedInvitations: [],
    receivedInvitations: [],
    gifts: [],
    giftFromFriend: '',
    optInRewardDate: 0,
    messageIds: [],
    optInShown: false,
    optInRequired: false,
    nativeOptInRequired: false,
    sharedGiftsCount: 0,
    sentCoins: [],
    sentGifts: [],
    requestedGifts: [],
    helperFriend: null,
};
